import { render, staticRenderFns } from "./detail-edit.vue?vue&type=template&id=4c7ba258"
import script from "./detail-edit.vue?vue&type=script&lang=js"
export * from "./detail-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports